import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  titleUI,
  radioSchema,
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import VaRadioField from 'platform/forms-system/src/js//web-component-fields/VaRadioField';
import { isYes, isRelationshipToVeteran } from '../../../../utils/helpers';
import { incomeSourceLabels } from '../../../../utils/labels';
import { IncomeAssetStatementFormAlert } from '../../../../components/FormAlerts';
import content from '../../../../utils/content.json';

const WhatWeConsiderIncome = props => {
  const { formData } = props;
  let descriptionContent =
    'Your income is how much you earn. It includes your Social Security benefits, investment and retirement payments, and any income your dependents receive.';
  if (isRelationshipToVeteran(formData) === 'child') {
    descriptionContent =
      'Your income is how much you earn. It includes your Social Security benefits, investment and retirement payments, and any income your dependent members of your household receive.';
  }
  return (
    <va-additional-info trigger="What we consider income">
      <p>{descriptionContent}</p>
    </va-additional-info>
  );
};

WhatWeConsiderIncome.propTypes = {
  formData: PropTypes.object,
};

const mapStateToProps = state => ({
  formData: state.form?.data,
});
// ui:description doesn't have access to formData out of the box.
const ConnectedWhatWeConsiderIncome =
  connect(mapStateToProps)(WhatWeConsiderIncome);

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['financial-info-income-sources-title']),
    // No title changes for 2022 version.
    moreThanFourIncomeSources: {
      ...yesNoUI({
        title: content['financial-info-income-sources-count-2022'],
      }),
      'ui:required': formData =>
        !formData?.survivorsBenefitsForm2025VersionEnabled,
      'ui:options': {
        hideIf: formData => formData?.survivorsBenefitsForm2025VersionEnabled,
      },
    },
    incomeSourcesCount: {
      'ui:webComponentField': VaRadioField,
      'ui:required': formData =>
        formData?.survivorsBenefitsForm2025VersionEnabled,
      'ui:options': {
        hideIf: formData => !formData?.survivorsBenefitsForm2025VersionEnabled,
        updateSchema: (formData, schema, uiSchema) => {
          const newUISchema = { ...uiSchema };
          const newSchema = { ...schema };
          newSchema.enumNames = Object.values(incomeSourceLabels);
          if (isRelationshipToVeteran(formData) === 'spouse') {
            newUISchema.title =
              content['financial-info-income-sources-count-spouse'];
          } else if (isRelationshipToVeteran(formData) === 'child') {
            newUISchema.title =
              content['financial-info-income-sources-count-child'];
          } else if (isRelationshipToVeteran(formData) === 'custodian') {
            newUISchema.title =
              content['financial-info-income-sources-count-custodian'];
          }
          return {
            ...newSchema,
            ...newUISchema,
          };
        },
      },
    },
    incomeAssetStatementFormAlert: {
      'ui:description': IncomeAssetStatementFormAlert,
      'ui:options': {
        hideIf: formData => {
          if (!formData?.survivorsBenefitsForm2025VersionEnabled) {
            return !formData?.moreThanFourIncomeSources;
          }
          return !['MORE_THAN_FIVE_SOURCES'].includes(
            formData?.incomeSourcesCount,
          );
        },
        displayEmptyObjectOnReview: true,
      },
    },
    whatWeConsiderIncome: {
      'ui:description': ConnectedWhatWeConsiderIncome,
    },
    otherIncome: {
      ...yesNoUI(),
      'ui:options': {
        updateSchema: formData => {
          let title = '';
          if (isRelationshipToVeteran(formData) === 'spouse') {
            title = content['financial-info-other-income-spouse'];
          } else if (isRelationshipToVeteran(formData) === 'child') {
            title = content['financial-info-other-income-child'];
          } else if (isRelationshipToVeteran(formData) === 'custodian') {
            title = content['financial-info-other-income-custodian'];
          }
          return {
            title,
          };
        },
      },
    },
    incomeAssetStatementFormAlertOtherIncome: {
      'ui:description': IncomeAssetStatementFormAlert,
      'ui:options': {
        hideIf: formData => !isYes(formData?.otherIncome),
        displayEmptyObjectOnReview: true,
      },
    },
  },
  schema: {
    type: 'object',
    required: ['otherIncome'],
    properties: {
      moreThanFourIncomeSources: yesNoSchema,
      incomeSourcesCount: radioSchema(Object.keys(incomeSourceLabels)),
      incomeAssetStatementFormAlert: {
        type: 'object',
        properties: {},
      },
      whatWeConsiderIncome: {
        type: 'object',
        properties: {},
      },
      otherIncome: yesNoSchema,
      incomeAssetStatementFormAlertOtherIncome: {
        type: 'object',
        properties: {},
      },
    },
  },
};
